import { icons } from "@/util/Icons";

export default {
  pagestyles() {
    return [
      {
        icon: icons("card"),
        title: "Card",
        type: "card"
      },
      {
        icon: icons("list"),
        title: "List",
        type: "list"
      },
      {
        icon: icons("table"),
        title: "Table",
        type: "table"
      },
      {
        icon: icons("data-grid"),
        title: "Data grid",
        type: "data-grid"
      },
      {
        icon: icons("checklist"),
        title: "Checklist",
        type: "checklist"
      },
      {
        icon: icons("calendar"),
        title: "Calendar",
        type: "calendar"
      },
      {
        icon: icons("kanban"),
        title: "Kanban",
        type: "kanban"
      },
      {
        icon: icons("custom"),
        title: "Custom",
        type: "custom"
      }
    ];
  },

  formstyles() {
    return [
      {
        icon: icons("list"),
        title: "Default",
        type: "default"
      },
      {
        icon: icons("kanban"),
        title: "Multistep",
        type: "multistep"
      }
      // {
      //   icon: icons("custom"),
      //   title: "Full page",
      //   type: "fullpage"
      // }
    ];
  },

  formvariants() {
    return [
      {
        icon: icons("multistep-design1"),
        title: "Design 1",
        type: 1
      },
      {
        icon: icons("multistep-design2"),
        title: "Design 2",
        type: 2
      },
      {
        icon: icons("multistep-design3"),
        title: "Design 3",
        type: 3
      }
    ];
  },
  executeCommand(command) {
    document.execCommand(command);
  },
  setFormatBlock(format) {
    document.execCommand("formatBlock", false, format);
  },
  generateTableOfContents(editableDiv) {
    const toc = [];
    const headings = editableDiv.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `heading-${index}`;
      }

      const headingLevel = heading.tagName.toLowerCase();
      const tocClass = `toc-${headingLevel}`;

      toc.push({
        id: heading.id,
        text: heading.innerText,
        class: tocClass
      });
    });

    return toc;
  }
};
